import { CurrencyCode } from '../../constants'

export const enum FreeEntryType {
	Common = 'Common',
	Uncommon = 'Uncommon',
	Rare = 'Rare',
	Legendary = 'Legendary',
}

export interface JackpotSitAndGoBuyIn {
	currencyCode: CurrencyCode
	amount: number
}

export interface JackpotSitAndGoPayout {
	multiplier: number
	probability: number
	distribution: number[]
	blinds: number
}

export interface JackpotSitAndGoGame {
	buyIn: JackpotSitAndGoBuyIn
	numberOfPlayers: number
	startingChips: number
	timeBank: number
	freeEntryType: FreeEntryType
	payoutStructure: JackpotSitAndGoPayout[]
}
